import * as React from 'react'

import { requestGet } from '../../../modules/request/index'

function useSnackbarMonitor(
  showSnackbar: boolean,
  setShowSnackbar: (visible: boolean) => void,
  snackbarTimeout: number,
  onSettingsPage = false
): void {
  const timeoutRef = React.useRef<number>(snackbarTimeout)

  // initialize from server on non-settings pages
  React.useEffect(() => {
    if (onSettingsPage) { return }

    requestGet('/accessibility_setting', (body: { snackbar_duration?: number }) => {
      if (body.snackbar_duration != null) {
        timeoutRef.current = body.snackbar_duration
      }
    })
  }, [onSettingsPage])

  // immediately apply any local change when on the settings page
  React.useEffect(() => {
    if (!onSettingsPage) { return }

    timeoutRef.current = snackbarTimeout
  }, [onSettingsPage, snackbarTimeout])

  React.useEffect(() => {
    if (!showSnackbar) return

    const timerId = window.setTimeout(() => {
      setShowSnackbar(false)
    }, timeoutRef.current)

    return () => {
      window.clearTimeout(timerId)
    }
  }, [showSnackbar, setShowSnackbar])
}

export default useSnackbarMonitor
